export default function textValidator(input) {
    const regex = /^[A-Za-z]+$/; // Matches only letters (uppercase and lowercase)
    return regex.test(input);
}
